
import style from '@style/recommend.module.scss'

function assert (source, key, defaultValue) {
  try {
    return source[key] || defaultValue
  } catch (e) {
    return defaultValue
  }
}

export {
  style
}

export default {
  props: ['dataSource'],

  data () {
    return {
      style
    }
  },

  methods: {
    onClick (item) {
      const type = item.redirectType
      const url = item.redirectUrl
      // const courseBool = item.searchAllWork
      const regHost = /^http(s)?:\/\/edu-m\.wps\.cn/
      const regCategories = /^[\d\w,.]+$/im
      // if (courseBool) {

      //   return
      // }
      if (type === 0 || type === 4) {
        if (regHost.test(url)) {
          // 本站跳转
          this.$router.push(url.replace(regHost, ''))
        } else if (regCategories.test(url)) {
          // 标签页面跳转
          this.$router.push(`/list/${url}`)
        } else {
          // 直接跳转
          window.location.href = url
        }
      } else {
        alert(`跳转失败 (redirectType=${type})`)
      }
    }
  },

  computed: {
    title () {
      return assert(this.dataSource, 'title', '')
    },

    list () {
      return assert(this.dataSource, 'operationVoList', [])
    }
  }
}
